import fetch from "unfetch";

export const authenticateEflowUser = async ({ email, password }) => {
  const url = `${process.env.REACT_APP_WORKFLOW_URL}/api/auth/auth-by-email`;
  const body = { email, password };

  return await fetchJSON({
    url,
    body,
    method: "POST",
  });
};

async function fetchJSON({ url, body, method }) {
  const response = await fetch(url, {
    method,
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
    },
  });

  return await response.json();
}
